/* eslint-disable import/prefer-default-export */
import React from 'react';
import Login from "app/pages/Login/Login";
import ResetPassword from "app/pages/ResetPassword/ResetPassword";
import Dashboard from 'app/pages/Dashboard/Dashboard';
import PortofolioPage from 'app/pages/PortofolioPage/PortofolioPage';
import UserPortofolioPage from 'app/pages/UserPortofolioPage/UserPortofolioPage';
import TransactionHistoryPage from 'app/pages/TransactionHistoryPage/TransactionHistoryPage';
import Marketplace from 'app/pages/Marketplace/Marketplace';
import MarketplaceList from 'app/pages/MarketplaceList/MarketplaceList';
import SidebarLayout from 'app/pages/SidebarLayout/SidebarLayout';
import PrivyComponent from 'app/pages/PrivyComponent/PrivyComponent';
import AfterFundingPage from 'app/pages/AfterFundingPage/AfterFundingPage';
import AfterWithdrawPage from 'app/pages/AfterWithdrawPage/AfterWithdrawPage';
import Deposit from 'app/pages/Deposit/Deposit';
import BulkMarketplaceSummaryList from 'app/pages/BulkMarketplaceSummary/BulkMarketPlaceSummaryList';
import ROUTER_PATH from './routerPath';

const path = ROUTER_PATH;

export const privateRoutes = [
    {
        component: <SidebarLayout />,
        path: "",
        child: [
            {
                component: <Dashboard />,
                path: '/dashboard/',
                child: [
                    {
                        component: <PortofolioPage />,
                        path: 'porto',
                    },
                    {
                        component: <UserPortofolioPage />,
                        path: 'user-porto',
                    },
                    {
                        component: <TransactionHistoryPage />,
                        path: 'transaction-history',
                    },
                ]
            },
            {
                component: <Marketplace />,
                path: '/marketplace/',
                child: [
                    {
                        component: <MarketplaceList />,
                        path: 'list',
                    },
                ]
            },
            {
                component: <BulkMarketplaceSummaryList />,
                path: '/bulk-list/:upload_secure_id/:total_loan/:total_loan_amount/:loan_type_id',
            },
        ],
    },
    {
        component: <Deposit />,
        path: '/deposit',
        child: []
    }
];

export const privateRouteWithoutSidebar = [
    {
        component: <PrivyComponent />,
        path: '/privy',
        child: []
    },
	{
		component: <AfterFundingPage />,
        path: 'fundingStatus',
        child: []
	},
    {
		component: <AfterWithdrawPage />,
        path: '/withdrawStatus',
        child: []
	},
];

export const guestOnlyRoutes = [
    {
        component: <Login />,
        path: path.login,
        child: []
    },
];

export const routes = [
    {
        component: <ResetPassword />,
        path: path.login,
        child: []
    },
];
